import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth';
import { Landing } from './routes/landing';
import { Landed } from './routes/landed';
import { Tenants } from './routes/tenants';
import { Engines } from './routes/engines';
import { RequireAuth } from './components/RequireAuth';

function Nav() {
  const { me, signOut } = useAuth();
  const loc = useLocation();
  const isProtected = loc.pathname !== '/' && loc.pathname !== '/auth/landed';

  if (!isProtected || !me) return null;

  return (
    <nav className="border-b border-slate-800 bg-slate-900/60 px-6 py-3">
      <div className="mx-auto max-w-5xl flex items-center justify-between">
        <div className="flex items-center gap-6">
          <span className="text-xs uppercase tracking-widest text-sky-400 font-semibold">
            Clarity Admin
          </span>
          <Link
            to="/tenants"
            className={`text-sm transition-colors ${
              loc.pathname === '/tenants'
                ? 'text-slate-100'
                : 'text-slate-400 hover:text-slate-200'
            }`}
          >
            Tenants
          </Link>
          <Link
            to="/engines"
            className={`text-sm transition-colors ${
              loc.pathname === '/engines'
                ? 'text-slate-100'
                : 'text-slate-400 hover:text-slate-200'
            }`}
          >
            Engines
          </Link>
        </div>
        <div className="flex items-center gap-4 text-sm text-slate-400">
          <span>{me.user.email}</span>
          <button onClick={signOut} className="underline hover:text-slate-200">
            Sign out
          </button>
        </div>
      </div>
    </nav>
  );
}

function AdminRoutes() {
  return (
    <div className="min-h-screen">
      <Nav />
      <main className="mx-auto max-w-5xl px-6 py-8">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth/landed" element={<Landed />} />
          <Route
            path="/tenants"
            element={
              <RequireAuth>
                <>
                  <h1 className="mb-6 text-2xl font-semibold">Tenants</h1>
                  <Tenants />
                </>
              </RequireAuth>
            }
          />
          <Route
            path="/engines"
            element={
              <RequireAuth>
                <>
                  <h1 className="mb-6 text-2xl font-semibold">Engines</h1>
                  <Engines />
                </>
              </RequireAuth>
            }
          />
        </Routes>
      </main>
    </div>
  );
}

export function App() {
  return (
    <AuthProvider>
      <AdminRoutes />
    </AuthProvider>
  );
}
